import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import { AppContext } from '../../global/AppContext';
import { getOpenLiveBets, acceptOpenLiveBet, TAKEOUT_TYPES } from '../../global/request/bet';
import { AuthContext } from '../authentication/AuthContext';
import TakerFightProcess from '../fight/takerFightProcess/TakerFightProcess';

const ReferralModal = ({ foodfightId, onClose }) => {
  const [fightData, setFightData] = useState(null);
  const [loading, setLoading] = useState(false);
  const takerProcessRef = useRef(null);
  const authCtx = useContext(AuthContext);
  const appCtx = useContext(AppContext);

  useEffect(() => {
    if (!foodfightId) return;

    const fetchFight = async () => {
      setLoading(true);
      try {
        const bets = await getOpenLiveBets(authCtx.tokens.idToken);
        const fight = bets.find(bet => bet.id === Number(foodfightId));
        if (fight) {
          setFightData(fight);
          setTimeout(() => {
            // takerProcessRef.current?.present();
            takerProcessRef.current?.skipToSummary();
          }, 200);
        } else {
          onClose(); // fight not found
          console.log('fight not found');
        }
      } catch (error) {
        console.error('Failed to fetch referral fight:', error);
        onClose();
      } finally {
        setLoading(false);
      }
    };

    fetchFight();
  }, [foodfightId, onClose, authCtx.tokens.idToken]);

  const optionalTakerVenue = useMemo(() => {
    if (fightData?.takeoutType === TAKEOUT_TYPES.DELIVERY && fightData.restaurant) {
      return {
        id: fightData.restaurant.id,
        name: fightData.restaurant.name,
        takeoutType: fightData.isDelivery ? TAKEOUT_TYPES.DELIVERY : TAKEOUT_TYPES.IN_PERSON,
      };
    }
    return null;
  }, [fightData]);

  const handleAcceptFight = async (betId, payment, address, items, deliveryInstructions, deliveryLat, deliveryLng) => {
    try {
      await acceptOpenLiveBet(
        appCtx.tokens.idToken,
        betId,
        payment,
        address,
        items,
        deliveryInstructions,
        deliveryLat,
        deliveryLng,
      );
      onClose();
    } catch (error) {
      console.error('Error accepting referral fight:', error);
    }
  };

  if (!foodfightId || loading || !fightData) return null;

  return (
    <TakerFightProcess
      ref={takerProcessRef}
      fightData={fightData}
      onAcceptFight={handleAcceptFight}
      optionalTakerVenue={optionalTakerVenue}
      onClose={onClose}
    />
  );
};

export default ReferralModal;
